export abstract class BaseService {
    static API_NAME = 'dsapi';
    static NEWSLETTER_ENDPOINT = '/newsletter';
    static CONTACT_ENDPOINT = '/contact';
}